import React from "react";
import Typography from "components/Typography";
import classes from "./GoodsamInsuranceDesktopTableTh.module.css";
import cn from 'classnames';
import { checkGreenIcon } from "components/Icon";
import { StringItem } from "components/StringItem";
import { PROMO_TYPES } from "../../constants";

export const GoodsamInsuranceDesktopTableTh = (props) => {
  const { name, price, promo, promoType, isSelectedPlan, header } = props;

  return (
    <div className={cn(classes.container)}>
      <div className={classes.containerInner}>
        <div className={classes.content}>
          {isSelectedPlan && (
            <div className={classes.selectedPlanIcon}>
              {checkGreenIcon}
            </div>
          )}

          {header ? (
            <Typography
              variant="headline"
              size="s"
              weight="bold"
              className={classes.header}
            >
              {header}
            </Typography>
          ) : null}

          {promo ? (
            <div className={classes.promoContainer}
            >
              <div className={cn(
                classes.promoContainerInner,
                promoType === PROMO_TYPES.BEST_VALUE && classes.bestValue,
                promoType === PROMO_TYPES.PEACE_OF_MIND && classes.peaceOfMind
              )}>
                <StringItem
                  data={promo}
                  headerStyle={classes.promo}
                  headerProps={{
                    variant: "headline",
                    size: "s",
                    weight: "bold"
                  }}
                  textStyle={classes.promo}
                  textProps={{
                    variant: "headline",
                    size: "s",
                    weight: "bold"
                  }}
                />
              </div>
            </div>
          ) : null}

          {name ? (
            <Typography
              variant="headline"
              size="s"
              weight="bold"
              className={classes.title}
            >
              {name}
            </Typography>
          ) : null}

          {price ? (
            <Typography
              variant="subtitle"
              size="m"
              className={classes.price}
            >
              ${price}/day
            </Typography>
          ) : null}
        </div>
      </div>
    </div>
  );
};
